import React from 'react';
//Components
import ProductSearch from '../ProductSearch/ProductSearch';

export default function ProductSearchContainer() {
  return <ProductSearch />;
}
